import classNames from 'classnames';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@feathr/components';

import * as styles from './LeftPanelTabs.css';

interface IProps {
  activeTab: 'settings' | 'design';
  handleTabClick: (tab: 'settings' | 'design') => void;
}

function LeftPanelTabsBeta(props: Readonly<IProps>): JSX.Element {
  props;
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <button className={classNames(styles.tab, styles.tabBeta)}>
        <Text.LargeSemibold>{t('Donation Amounts')}</Text.LargeSemibold>
      </button>
    </div>
  );
}

export default LeftPanelTabsBeta;
